document.addEventListener('click', function (e) {

  /* -- image prev/next -- */
  var imgBtn = e.target.closest('[data-solar-img-prev], [data-solar-img-next]');
  if (imgBtn) {
    e.preventDefault();
    e.stopPropagation();
    var wrap = imgBtn.closest('.solar-card__image-wrap');
    var imgs = wrap.querySelectorAll('.solar-card__img');
    var dots = wrap.querySelectorAll('.solar-img-dot');
    var current = 0;
    imgs.forEach(function (img, i) { if (img.classList.contains('is-active')) current = i; });
    var isPrev = imgBtn.hasAttribute('data-solar-img-prev');
    var next = isPrev ? (current - 1 + imgs.length) % imgs.length : (current + 1) % imgs.length;
    imgs.forEach(function (img, i) { img.classList.toggle('is-active', i === next); });
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === next); });
    return;
  }

  /* -- qty stepper -- */
  var qtyBtn = e.target.closest('[data-solar-qty-minus], [data-solar-qty-plus]');
  if (qtyBtn) {
    e.preventDefault();
    e.stopPropagation();
    var group = qtyBtn.closest('[data-solar-cta-group]');
    var input = group.querySelector('[data-solar-qty-input]');
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (qtyBtn.hasAttribute('data-solar-qty-minus') && val > 1) val -= 1;
    if (qtyBtn.hasAttribute('data-solar-qty-plus')) val += 1;
    input.value = val;
    return;
  }

  /* -- add to cart (AJAX, redirects to /cart) -- */
  var addBtn = e.target.closest('[data-solar-add-to-cart]');
  if (addBtn) {
    e.preventDefault();
    e.stopPropagation();
    var group = addBtn.closest('[data-solar-cta-group]');
    var variantId = group.dataset.variantId;
    var qtyInput = group.querySelector('[data-solar-qty-input]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;
    var label = addBtn.querySelector('.solar-cta-label');
    var originalText = addBtn.dataset.originalText || (label ? label.textContent : addBtn.textContent);
    addBtn.dataset.originalText = originalText;
    if (label) label.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        if (label) label.textContent = 'Try again';
        setTimeout(function () {
          if (label) label.textContent = originalText;
        }, 1200);
      });
  }
});